import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import { request } from "@/js/http/http_request";
import { disconnect, getUserGroupFromToken, isAdminNotConsultant, isConsultantOrHolding, isBuyerGroup, getLimitedLocations, getClientAppData } from "@/js/http/auth";
import { listCurrencies, listWineRangeAccessibility, WineRangeAccessibilityEnum, COUNTRIES } from "@/js/lists.ts";
import { cleanErrors, noErrors, getErrorData } from "@/js/forms.js";
import { regExpPassword, regExpPhone, regExpMail } from "@/js/regexp_validation.js";
import { setCurrencyUsedForCartAndExplore } from "@/js/currency/currencies.js";
import { getCurrentOrder, removeOrderFromStorage, getThirdPartyUserSelected } from "@/js/order/order.js";
import { formRules } from "@/js/form_rules.js";
import { COUNTRY_SPECIAL_WORDINGS } from "@/js/user/user";
import addressComponent from "@/components/address/Address.vue";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
export default {
  name: "ProfileComponent",
  components: {
    "address-user": addressComponent,
    confirm: confirmationComponent
  },
  props: ["firstConnection", "btnStyle", "accountStatus", "loggedUserData"],
  data: function data() {
    return {
      clientAppData: null,
      addressChanged: false,
      errorLabels: {
        excise_code: "",
        login: "",
        new_password: "",
        password_confirm: "",
        name: "",
        nickname: "",
        phone: "",
        company_name: "",
        billingEmail: "",
        contactEmail: "",
        id_language: "",
        id_term: "",
        vat_code: ""
      },
      errorMessages: {
        mandatory: "This field is required",
        login: {
          format: "Incorrect format, valid email address expected"
        },
        phone: {
          format: "Incorrect format, valid phone number expected"
        },
        new_password: {
          tooeasy: "Your password should be at least 8 characters, 1 digit, 1 uppercase letter, 1 lowercase letter"
        },
        password_confirm: {
          nomatch: "Passwords do not match"
        }
      },
      user: {
        id_user: "",
        user_group: "",
        id_language: "",
        id_term: "",
        login: "",
        billingEmail: "",
        contactEmail: "",
        pass: "",
        active: "",
        last_connection_date: "",
        default_currency: "",
        factoring_provider: {
          id: null
        },
        nickname: "",
        name: "",
        phone: "",
        contact: "",
        vat_code: "",
        excise_code: "",
        company_name: "",
        consent: "",
        consultant_code: "",
        sponsorship_code: "",
        deleted: "",
        delivery_address: {
          street: "",
          address_line_2: "",
          address_line_3: "",
          address_complement: "",
          zip: "",
          city: "",
          state: "",
          country: "",
          oldCountry: ""
        },
        billing_address: {
          street: "",
          address_line_2: "",
          address_line_3: "",
          address_complement: "",
          zip: "",
          city: "",
          state: "",
          country: ""
        },
        first_connection: false,
        billing_is_delivery: null
      },
      initialCurrency: null,
      hide_billing_address: null,
      listCountries: [],
      listStates: [],
      isShowPassword: false,
      input: {
        new_password: "",
        password_confirm: ""
      },
      listCurrencies: listCurrencies,
      isConsultant: false,
      isUserAssociatedToConsultant: false,
      readOnly: true,
      formConsultantCode: {
        valid: false,
        sending: false,
        items: [],
        message: null
      },
      accountStatusHeaders: [{
        text: "",
        value: "id",
        align: "center"
      }, {
        text: "Name",
        value: "textForUsers",
        align: "left"
      }],
      managedExceptions: {
        warning: {
          login_exists: "This email address is already used"
        }
      },
      rules: formRules,
      isAdminNotConsultant: isAdminNotConsultant
    };
  },
  computed: {
    canChangeCurrency: function canChangeCurrency() {
      return this.listDefaultCurrencies.length > 1;
    },
    listDefaultCurrencies: function listDefaultCurrencies() {
      var _this$user,
        _this$user2,
        _this$user$factoring_,
        _this2 = this;
      var availableCurrencies = [];
      if (((_this$user = this.user) === null || _this$user === void 0 || (_this$user = _this$user.delivery_address) === null || _this$user === void 0 || (_this$user = _this$user.country) === null || _this$user === void 0 ? void 0 : _this$user.id_country) === COUNTRIES.USA.id) {
        availableCurrencies = ["USD"];
      } else if (((_this$user2 = this.user) === null || _this$user2 === void 0 || (_this$user2 = _this$user2.delivery_address) === null || _this$user2 === void 0 || (_this$user2 = _this$user2.country) === null || _this$user2 === void 0 ? void 0 : _this$user2.id_country) === COUNTRIES.BAHAMAS.id) {
        availableCurrencies = ["BSD", "USD"];
      } else {
        var _this$user3;
        availableCurrencies.push("EUR");
        if ((_this$user3 = this.user) !== null && _this$user3 !== void 0 && (_this$user3 = _this$user3.delivery_address) !== null && _this$user3 !== void 0 && (_this$user3 = _this$user3.country) !== null && _this$user3 !== void 0 && _this$user3.currency) availableCurrencies.push(this.user.delivery_address.country.currency);
      }
      if (((_this$user$factoring_ = this.user.factoring_provider) === null || _this$user$factoring_ === void 0 || (_this$user$factoring_ = _this$user$factoring_.currencies) === null || _this$user$factoring_ === void 0 ? void 0 : _this$user$factoring_.length) > 0) {
        availableCurrencies = availableCurrencies.filter(function (x) {
          return _this2.user.factoringProvider.currencies.includes(x);
        });
      }
      return listCurrencies.filter(function (x) {
        return availableCurrencies.includes(x.id);
      });
    },
    listCategoryUser: function listCategoryUser() {
      var list = listWineRangeAccessibility;
      return list.sort(function (a, b) {
        return b.id - a.id;
      });
    },
    listCountriesForDeliveryAddress: function listCountriesForDeliveryAddress() {
      var _this$user$factoring_2,
        _this3 = this;
      var copyCountries = _toConsumableArray(this.listCountries);
      var limitedLocations = getLimitedLocations(this.loggedUserData);
      if ((limitedLocations === null || limitedLocations === void 0 ? void 0 : limitedLocations.length) > 0) {
        var _this$user4;
        var countryIds = limitedLocations.map(function (x) {
          return x.country_id;
        });
        var deliveryCountryId = (_this$user4 = this.user) === null || _this$user4 === void 0 || (_this$user4 = _this$user4.delivery_address) === null || _this$user4 === void 0 || (_this$user4 = _this$user4.country) === null || _this$user4 === void 0 ? void 0 : _this$user4.id_country;
        if (deliveryCountryId > 0 && !countryIds.includes(deliveryCountryId)) {
          countryIds.push(deliveryCountryId);
        }
        copyCountries = copyCountries.filter(function (x) {
          return countryIds.includes(x.id_country);
        });
      }
      if (!this.canManageFactoringProviders && (_this$user$factoring_2 = this.user.factoring_provider) !== null && _this$user$factoring_2 !== void 0 && _this$user$factoring_2.id) {
        return copyCountries.filter(function (x) {
          return _this3.user.factoring_provider.currencies.includes(x.currency) || _this3.user.factoring_provider.currencies.includes("EUR") && x.currency != "USD";
        });
      }
      return copyCountries;
    },
    isUserIndividual: function isUserIndividual() {
      return this.user.user_group == "USER";
    },
    liquorNumberLabel: function liquorNumberLabel() {
      var _Object$values$find$l,
        _Object$values$find,
        _this4 = this;
      return (_Object$values$find$l = (_Object$values$find = Object.values(COUNTRY_SPECIAL_WORDINGS).find(function (x) {
        var _this4$user;
        return x.countryId == ((_this4$user = _this4.user) === null || _this4$user === void 0 || (_this4$user = _this4$user.delivery_address) === null || _this4$user === void 0 || (_this4$user = _this4$user.country) === null || _this4$user === void 0 ? void 0 : _this4$user.id_country);
      })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.liquorNumberLabel) !== null && _Object$values$find$l !== void 0 ? _Object$values$find$l : "Liquor certificate number";
    },
    taxIdLabel: function taxIdLabel() {
      var _Object$values$find$t,
        _Object$values$find2,
        _this5 = this;
      return (_Object$values$find$t = (_Object$values$find2 = Object.values(COUNTRY_SPECIAL_WORDINGS).find(function (x) {
        var _this5$user;
        return x.countryId == ((_this5$user = _this5.user) === null || _this5$user === void 0 || (_this5$user = _this5$user.delivery_address) === null || _this5$user === void 0 || (_this5$user = _this5$user.country) === null || _this5$user === void 0 ? void 0 : _this5$user.id_country);
      })) === null || _Object$values$find2 === void 0 ? void 0 : _Object$values$find2.taxIdLabel) !== null && _Object$values$find$t !== void 0 ? _Object$values$find$t : "VAT/Tax number";
    },
    individualCodeLabel: function individualCodeLabel() {
      var _Object$values$find$i,
        _Object$values$find3,
        _this6 = this;
      return (_Object$values$find$i = (_Object$values$find3 = Object.values(COUNTRY_SPECIAL_WORDINGS).find(function (x) {
        var _this6$user;
        return x.countryId == ((_this6$user = _this6.user) === null || _this6$user === void 0 || (_this6$user = _this6$user.delivery_address) === null || _this6$user === void 0 || (_this6$user = _this6$user.country) === null || _this6$user === void 0 ? void 0 : _this6$user.id_country);
      })) === null || _Object$values$find3 === void 0 ? void 0 : _Object$values$find3.individualCodeLabel) !== null && _Object$values$find$i !== void 0 ? _Object$values$find$i : "Legal code";
    }
  },
  created: function created() {
    document.body.style.cursor = "wait";
    this.clientAppData = getClientAppData(this);
    var _this = this;
    if (_this.firstConnection) {
      _this.readOnly = false;
    }
    _this.getUser();
    request("/v1/countries?implantedMarket=true", "post", _this.clientAppData, false, "api").then(function (response) {
      _this.listCountries = _toConsumableArray(response.data.countries);
      _this.listStates = _toConsumableArray(response.data.states);
      _this.user.delivery_address.oldCountry = _this.user.delivery_address.country;
      _this.user.billing_address.oldCountry = _this.user.billing_address.country;
    }).catch(function (e) {
      _this.$toasted.show("An error occured. Please contact an administrator.", {
        type: "error"
      });
    });
  },
  methods: {
    routeFinalizeCart: function routeFinalizeCart() {
      return {
        name: "finalizeCart"
      };
    },
    changeBillingAddress: function changeBillingAddress(e, isSameChecked) {
      if (!this.hide_billing_address) return;
      this.changeCountry(this.user.billing_address, e, isSameChecked);
    },
    changeDeliveryAddress: function changeDeliveryAddress(e) {
      var _this$user5, _this$user6;
      this.changeCountry(this.user.delivery_address, e);
      if (((_this$user5 = this.user) === null || _this$user5 === void 0 || (_this$user5 = _this$user5.delivery_address) === null || _this$user5 === void 0 || (_this$user5 = _this$user5.country) === null || _this$user5 === void 0 ? void 0 : _this$user5.currency) === "USD" || ((_this$user6 = this.user) === null || _this$user6 === void 0 || (_this$user6 = _this$user6.delivery_address) === null || _this$user6 === void 0 || (_this$user6 = _this$user6.country) === null || _this$user6 === void 0 ? void 0 : _this$user6.currency) === "EUR") {
        var _this$user7;
        this.user.default_currency = (_this$user7 = this.user) === null || _this$user7 === void 0 || (_this$user7 = _this$user7.delivery_address) === null || _this$user7 === void 0 || (_this$user7 = _this$user7.country) === null || _this$user7 === void 0 ? void 0 : _this$user7.currency;
      }
      if (this.hide_billing_address) {
        this.user.billing_address.country = e;
      }
    },
    changeCountry: function changeCountry(currentAddress, newAddress, isSameChecked) {
      var _order$items;
      var _this = this;
      var order = getCurrentOrder();
      if ((order === null || order === void 0 || (_order$items = order.items) === null || _order$items === void 0 ? void 0 : _order$items.length) > 0 && newAddress.instanceof === "country") {
        this.$refs.confirm.open("Warning", "Your cart contains some wines. When saving, your cart will be lost.", {
          color: "red"
        }).then(function (confirm) {
          if (confirm) {
            _this.addressChanged = true;
            currentAddress.country = newAddress;
            if (isSameChecked) {
              _this.hide_billing_address = true;
            }
          } else {
            currentAddress.country = currentAddress.oldCountry;
            if (isSameChecked) {
              _this.hide_billing_address = false;
            }
          }
        });
      }
    },
    getUser: function getUser() {
      this.$EventBus.$emit("loading", true);
      var _this = this;
      request("/v1/user", "get", null, true, "api").then(function (response) {
        var _this$user$consultant, _this$user$sponsorshi;
        _this.user = _objectSpread({}, response.data);
        _this.user.billing_is_delivery = _this.compareAddresses();
        _this.hide_billing_address = _this.user.billing_is_delivery;
        _this.initialCurrency = _this.user.default_currency;
        _this.isConsultant = _this.user.user_group == "ADMIN" && ((_this$user$consultant = _this.user.consultant_code) === null || _this$user$consultant === void 0 ? void 0 : _this$user$consultant.length) > 0;
        _this.isUserAssociatedToConsultant = isBuyerGroup(_this.user.user_group) && ((_this$user$sponsorshi = _this.user.sponsorship_code) === null || _this$user$sponsorshi === void 0 ? void 0 : _this$user$sponsorshi.length) > 0;
        if (_this.isUserAssociatedToConsultant) {
          request("/v1/consultant/".concat(_this.user.sponsorship_code), "get", null, true, "api").then(function (response) {
            var _this$user$delivery_a;
            _this.isUserAssociatedToConsultant = true;
            if (_this.firstConnection && !((_this$user$delivery_a = _this.user.delivery_address) !== null && _this$user$delivery_a !== void 0 && (_this$user$delivery_a = _this$user$delivery_a.country) !== null && _this$user$delivery_a !== void 0 && _this$user$delivery_a.id_country)) {
              _this.user.delivery_address.country = response.data.delivery_address.country;
              _this.user.billing_address.country = response.data.delivery_address.country;
            }
          }).catch(function (e) {
            var _e$response;
            if (((_e$response = e.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 || (_e$response = _e$response.value) === null || _e$response === void 0 ? void 0 : _e$response.errorCode) == "user_not_found") {
              //That means it's a simple keypass
              _this.isUserAssociatedToConsultant = false;
            } else {
              throw e;
            }
          });
        }
        _this.$EventBus.$emit("loading", false);
      }).catch(function (_) {
        _this.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
        _this.$EventBus.$emit("loading", false);
      });
    },
    compareAddresses: function compareAddresses() {
      var delivery = _objectSpread({}, this.user.delivery_address);
      delete delivery.id_address;
      delete delivery.deliveryInstructions;
      var billing = _objectSpread({}, this.user.billing_address);
      delete billing.id_address;
      delete billing.deliveryInstructions;
      return JSON.stringify(delivery) == JSON.stringify(billing);
    },
    updateAccount: function updateAccount() {
      this.user.billing_is_delivery = this.hide_billing_address;
      var _this = this;
      if (_this.validateInputsUpdateAccount()) {
        _this.$EventBus.$emit("loading", true);
        document.body.style.cursor = "wait";
        _this.user.pass = this.input.new_password;
        if (_this.user.billing_is_delivery && !_this.compareAddresses()) {
          _this.user.billing_address = _objectSpread({}, _this.user.delivery_address);
          _this.user.billing_address.id_address = 0;
        }
        if (_this.firstConnection) {
          _this.user.first_connection = false;
        }
        var order = getCurrentOrder();
        request("/v1/user", "put", _this.user, true, "api").then(function () {
          var _order$items2;
          _this.input.new_password = "";
          _this.input.password_confirm = "";
          if ((order === null || order === void 0 || (_order$items2 = order.items) === null || _order$items2 === void 0 ? void 0 : _order$items2.length) > 0 && (_this.addressChanged || _this.initialCurrency !== _this.user.default_currency)) {
            var data = {
              orderId: order.id_order,
              userId: order.id_user
            };
            request("/v1/basket/".concat(order.id_order), "delete", data, true, "api").then(function () {
              removeOrderFromStorage();
              _this.$EventBus.$emit("BasketRemoved");
              _this.$EventBus.$emit("ItemRemoved", {
                detail: {
                  items: []
                }
              });
            });
          }
          if (_this.initialCurrency !== _this.user.default_currency) {
            var _getThirdPartyUserSel;
            _this.initialCurrency = _this.user.default_currency;
            var thirdPartySelected = (_getThirdPartyUserSel = getThirdPartyUserSelected()) === null || _getThirdPartyUserSel === void 0 ? void 0 : _getThirdPartyUserSel.id_user;
            var isUserBuyerGroup = isBuyerGroup(_this.user.user_group);
            var changeCurrencyUsedForCartAndExplore = isUserBuyerGroup || !isUserBuyerGroup && (!thirdPartySelected || thirdPartySelected === _this.user.id_user);
            if (changeCurrencyUsedForCartAndExplore) {
              setCurrencyUsedForCartAndExplore(_this.user.default_currency);
              _this.$EventBus.$emit("CurrencyUpdated", _this.user.default_currency);
            }
          }
          _this.$toasted.show("Account updated.", {
            type: "success"
          });
          _this.$EventBus.$emit("loading", false);
          if (_this.firstConnection) {
            var urlRedirection = _this.$whitelabel.routeAfterLogin;
            if (urlRedirection === "wineList" || urlRedirection === "productList") {
              var userGroup = getUserGroupFromToken();
              switch (userGroup) {
                case "USER":
                case "HORECA":
                case "WHOLESALER":
                  urlRedirection = "userProductList";
                  break;
                case "ADMIN":
                  urlRedirection = "adminProductList";
                  break;
              }
            }
            _this.$router.push({
              name: urlRedirection
            });
          } else {
            _this.readOnly = true;
          }
          return;
        }).catch(function (e) {
          var errorData = getErrorData(e, _this.managedExceptions);
          _this.$toasted.show(errorData.message, {
            type: errorData.type
          });
        });
      }
    },
    deleteAccount: function deleteAccount() {
      var _this = this;
      this.$refs.confirm.open("Delete", "Are you sure you want to delete your account ? This action cannot be undone. ", {
        color: "red"
      }).then(function (confirm) {
        if (confirm == true) {
          request("/v1/user", "delete", null, true, "api").then(function (response) {
            _this.$toasted.show("Account deleted.", {
              type: "success"
            });
            disconnect(_this);
            _this.$router.push({
              name: "login"
            });
          }).catch(function (err) {
            _this.$toasted.show("An error occured. Please contact an administrator.", {
              type: "error"
            });
          });
        }
      });
    },
    validateInputsUpdateAccount: function validateInputsUpdateAccount() {
      this.errorLabels = cleanErrors(this.errorLabels);
      if (this.user.login == "") {
        this.errorLabels.login = this.errorMessages.mandatory;
      } else if (!regExpMail.test(this.user.login)) {
        this.errorLabels.login = this.errorMessages.login.format;
      }
      if (this.user.nickname == "") {
        this.errorLabels.nickname = this.errorMessages.mandatory;
      }
      if (!this.user.excise_code && (this.user.user_group === "HORECA" || this.user.user_group === "WHOLESALER") && (this.user.delivery_address.country.iso_code === "USA" || this.user.delivery_address.country.iso_code === "BRA")) {
        this.errorLabels.excise_code = this.errorMessages.mandatory;
      }
      if (this.user.name == "") {
        this.errorLabels.name = this.errorMessages.mandatory;
      }
      if (this.user.phone == "") {
        this.errorLabels.phone = this.errorMessages.mandatory;
      } else if (!regExpPhone.test(this.user.phone)) {
        this.errorLabels.phone = this.errorMessages.phone.format;
      }
      if (!this.user.company_name && (this.user.user_group == "HORECA" || this.user.user_group == "WHOLESALER" || this.user.isHolding)) {
        this.errorLabels.company_name = this.errorMessages.mandatory;
      }
      if (!String.isNullOrEmpty(this.user.billingEmail) && !regExpMail.test(this.user.billingEmail)) {
        this.errorLabels.billingEmail = this.errorMessages.login.format;
      }
      if (!String.isNullOrEmpty(this.user.contactEmail) && !regExpMail.test(this.user.contactEmail)) {
        this.errorLabels.contactEmail = this.errorMessages.login.format;
      }
      if (!this.user.vat_code && (this.user.user_group == "HORECA" || this.user.user_group == "WHOLESALER")) {
        this.errorLabels.vat_code = this.errorMessages.mandatory;
      }
      if (this.input.new_password != "" && !regExpPassword.test(this.input.new_password)) {
        this.errorLabels.new_password = this.errorMessages.new_password.tooeasy;
      }
      if (this.input.new_password != this.input.password_confirm) {
        this.errorLabels.password_confirm = this.errorMessages.password_confirm.nomatch;
      }
      if (this.user.id_language == "") {
        this.errorLabels.id_language = this.errorMessages.mandatory;
      }
      if (this.user.id_term == "") {
        this.errorLabels.id_term = this.errorMessages.mandatory;
      }
      //We test both address separatly because we want ALL errors to pop if both don't go through the validation
      //(and not display error for delivery first, then when he tries saving again, display errors for billing)
      var addressCheck = true;
      if (!this.$refs.addressDelivery.validateForm()) {
        addressCheck = false;
      }
      if (!this.user.billing_is_delivery) {
        if (!this.$refs.addressBilling.validateForm()) {
          addressCheck = false;
        }
      }
      if (!addressCheck) {
        return false;
      }
      return noErrors(this.errorLabels);
    },
    additionalDescription: function additionalDescription(item) {
      var _this$accountStatus;
      if ((_this$accountStatus = this.accountStatus) !== null && _this$accountStatus !== void 0 && _this$accountStatus.rangeAccessibility) {
        var missingAmount = 0;
        switch (item.id) {
          case WineRangeAccessibilityEnum.CORE_ITEM:
            if (this.accountStatus.rangeAccessibility === WineRangeAccessibilityEnum.PREMIUM || this.accountStatus.rangeAccessibility === WineRangeAccessibilityEnum.ULTRA_PREMIUM || this.accountStatus.rangeAccessibility === WineRangeAccessibilityEnum.FINE_AND_RARE) {
              return "You have surpassed the curious stage and have a deeper knowledge of wines.";
            }
            break;
          case WineRangeAccessibilityEnum.PREMIUM:
            if (this.accountStatus.rangeAccessibility === WineRangeAccessibilityEnum.ULTRA_PREMIUM || this.accountStatus.rangeAccessibility === WineRangeAccessibilityEnum.FINE_AND_RARE) {
              return "You have surpassed the connoisseur stage and are more knowledgeable about wines.";
            } else if (this.accountStatus.rangeAccessibility === WineRangeAccessibilityEnum.CORE_ITEM) {
              missingAmount = listWineRangeAccessibility.find(function (x) {
                return x.id == WineRangeAccessibilityEnum.PREMIUM;
              }).minAmount - (this.accountStatus.coreItemSpendingAmountNotValidated + this.accountStatus.totalSpendingAmountOnValidated);
              return "Only ".concat(this.generateMissingAmount(missingAmount), " to experience the exclusive wines of a connoisseur.");
            }
            break;
          case WineRangeAccessibilityEnum.ULTRA_PREMIUM:
            if (this.accountStatus.rangeAccessibility === WineRangeAccessibilityEnum.FINE_AND_RARE) {
              return "You have surpassed the infamous connoisseur stage and are highly esteemed in the wine community.";
            } else if (this.accountStatus.rangeAccessibility === WineRangeAccessibilityEnum.PREMIUM) {
              missingAmount = listWineRangeAccessibility.find(function (x) {
                return x.id == WineRangeAccessibilityEnum.ULTRA_PREMIUM;
              }).minAmount - (this.accountStatus.coreItemSpendingAmountNotValidated + this.accountStatus.premiumSpendingAmountNotValidated + this.accountStatus.totalSpendingAmountOnValidated);
              return "Only ".concat(this.generateMissingAmount(missingAmount), " to experience the legendary wines of an infamous connoisseur.");
            }
            break;
          case WineRangeAccessibilityEnum.FINE_AND_RARE:
            if (this.accountStatus.rangeAccessibility === WineRangeAccessibilityEnum.ULTRA_PREMIUM) {
              missingAmount = listWineRangeAccessibility.find(function (x) {
                return x.id == WineRangeAccessibilityEnum.FINE_AND_RARE;
              }).minAmount - (this.accountStatus.coreItemSpendingAmountNotValidated + this.accountStatus.premiumSpendingAmountNotValidated + this.accountStatus.ultraPremiumSpendingAmountNotValidated + this.accountStatus.totalSpendingAmountOnValidated);
              return "Only ".concat(this.generateMissingAmount(missingAmount), " to experience the exquisite wines of a thirsty connoisseur.");
            }
            break;
        }
      }
      return "";
    },
    generateMissingAmount: function generateMissingAmount(missingAmount) {
      var result = Math.ceil(missingAmount / 100);
      return result > 1 ? "".concat(result, " points") : "".concat(result, " point");
    },
    goToWinesFiltered: function goToWinesFiltered(item) {
      var query = {
        tab: "wines",
        rangeAccessibilities: item.id.toString(),
        stockOnly: "false"
      };
      if (isBuyerGroup(this.user.user_group)) {
        return {
          name: "userProductList",
          query: query
        };
      } else {
        return {
          name: "adminProductList",
          query: query
        };
      }
    },
    openToS: function openToS() {
      var anchor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var routeData = this.$router.resolve({
        name: "userTermsOfSales",
        hash: anchor
      });
      window.open(routeData.href);
    },
    isConsultantOrHolding: isConsultantOrHolding,
    isBuyerGroup: isBuyerGroup,
    getCurrentOrder: getCurrentOrder
  },
  watch: {
    listDefaultCurrencies: function listDefaultCurrencies(currencies) {
      var _this$user8;
      if (currencies.length === 1) {
        this.user.default_currency = currencies[0].id;
      } else if (currencies.length > 0 && !currencies.map(function (x) {
        return x.id;
      }).includes((_this$user8 = this.user) === null || _this$user8 === void 0 ? void 0 : _this$user8.default_currency)) {
        this.user.default_currency = currencies[0].id;
      } else if (currencies.length === 0) {
        this.user.default_currency = null;
      }
    }
  }
};